var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusBetNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 3.23438C8.57812 2.625 7.92188 2.25 7.21875 2.25H7.125C6.04688 2.25 5.25 3.09375 5.25 4.125C5.25 5.20312 6.04688 6 7.125 6H10.5H10.5469L8.90625 3.23438ZM3 4.125C3 1.875 4.82812 0 7.125 0H7.21875C8.71875 0 10.0781 0.796875 10.8281 2.10938L12 4.03125L13.125 2.10938C13.875 0.796875 15.2344 0 16.7344 0H16.875C19.125 0 21 1.875 21 4.125C21 4.82812 20.8125 5.4375 20.5312 6H22.5C23.2969 6 24 6.70312 24 7.5V10.5C24 11.3438 23.2969 12 22.5 12H1.5C0.65625 12 0 11.3438 0 10.5V7.5C0 6.70312 0.65625 6 1.5 6H3.42188C3.14062 5.4375 3 4.82812 3 4.125ZM18.75 4.125C18.75 3.09375 17.9062 2.25 16.875 2.25H16.7344C16.0312 2.25 15.4219 2.625 15.0469 3.23438L13.4062 6H13.5H16.875C17.9062 6 18.75 5.20312 18.75 4.125ZM1.5 13.5H10.5V24H3.75C2.48438 24 1.5 23.0156 1.5 21.75V13.5ZM13.5 24V13.5H22.5V21.75C22.5 23.0156 21.4688 24 20.25 24H13.5Z",
    fill: "#3182CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusBetNotification);
export default ForwardRef;